import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Box from "@mui/material/Box";
import { ToastContainer, toast } from "react-toastify";
import { TextField, Button, MenuItem, Modal, Stack, Typography } from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { get, post ,postzip} from "../library/Api";
import PulseLoader from "react-spinners/PulseLoader";
// import importIcon from "../assets/images/import.svg";
import { useCallback } from 'react';
import importIcon from "../assets/images/import.svg";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import deleteIcon from '../assets/images/delete.svg';
import deleteIconRed from "../assets/images/delete.png";

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Radio } from "antd";
import ConformationModal from "../commonComponents/Modals/ConformationModal";

const Reports = () => {

  const [value, setValue] = React.useState('1');
  const [withoutEmailData, setwithoutEmailData] = useState([]);
  const [withoutAccountData, setwithoutAccountData] = useState([]);
  const [withoutRfidData, setwithoutRfidData] = useState([]);
  const [withoutCompanyData, setwithoutCompanyData] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companies_formodals, setCompaniesForModal] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(3);
  const [selectedCompanyForModal, setselectedCompanyForModal] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [download, setdownload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage_Account, setCurrentPage_Account] = useState(1);
  const [currentPage_Rfid, setCurrentPage_Rfid] = useState(1);
  const [currentPage_Company, setCurrentPage_Company] = useState(1);
  const [totalPage, settotalPage] = useState('0');
  const [totalPage_Account, settotalPage_Account] = useState('0');
  const [totalPage_Rfid, settotalPage_Rfid] = useState('0');
  const [totalPage_Company, settotalPage_Company] = useState('0');
  const [updateEmailModal, triggerUpdateEmailModal] = useState(false)
  const [flashAccountModal, triggerFlashAccountModal] = useState(false)
  const [rfidModal, triggerRfidModal] = useState(false)
  const [companyModal, triggerCompanyModal] = useState(false)
  const [facilityCode, setfacilityCode] = useState("");
  const [rfid, setRfid] = useState("");
  const [cardId, setcardId] = useState("");
  const [flashAccountCustomerId, setflashAccountCustomerId] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [emailModalData, setEmailModalData] = useState("");
  const [selectedCustomerIdFromUpdateEmail, setselectedCustomerIdFromUpdateEmail] = useState(null);
  const [selectedCustomerFNameFromUpdateEmail, setselectedCustomerFNameFromUpdateEmail] = useState(null);
  const [selectedCustomerLNameFromUpdateEmail, setselectedCustomerLNameFromUpdateEmail] = useState("");
  const [customerIdForUpdateRfid, setcustomerIdForUpdateRfid] = useState(null)
  const [emailForUpdateRfid, setemailForUpdateRfid] = useState("")

  const [totalPage_ForIgnoreEmail, settotalPage_ForIgnoreEmail] = useState('0');
  const [totalPage_Email_ForIgnoreEmail, settotalPage_Email_ForIgnoreEmail] = useState('0');
  const [totalPage_Account_ForIgnoreAccount, settotalPage_Account_ForIgnoreAccount] = useState('0');
  const [totalPage_Rfid_ForIgnoreRfid, settotalPage_Rfid_ForIgnoreRfid] = useState('0');
  const [totalPage_Company_ForIgnoreCompany, settotalPage_Company_ForIgnoreCompany] = useState('0');


  const [currentPage_IgnoreEmail, setCurrentPage_IgnoreEmail] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const [withoutEmailData_IgnoredTab, setwithoutEmailData_IgnoredTab] = useState([]);
  const [withoutAccountData_IgnoreTab, setwithoutAccountData_IgnoreTab] = useState([]);
  const [withoutRfidData_IgnoreTab, setwithoutRfidtData_IgnoreTab] = useState([]);
  const [withoutCompanyData_IgnoreTab, setwithoutCompanyData_IgnoreTab] = useState([]);
  // GenerateModal
  const [updateGenerateModal, setUpdateGenerateModal] = useState(false);

  const [selectedRows_WEmail, setSelectedRows_WEmail] = useState([]);
  const [selectedRows_WAccount, setSelectedRows_WAccount] = useState([]);
  const [selectedRows_WRfid, setSelectedRows_WRfid] = useState([]);
  const [selectedRows_WCompany, setSelectedRows_WCompany] = useState([]);
  const [selectedRows_WIG_Email, setSelectedRows_WIG_Email] = useState([]);
  const [selectedRows_WIG_Account, setSelectedRows_WIG_Account] = useState([]);
  const [selectedRows_WIG_Rfid, setSelectedRows_WIG_Rfid] = useState([]);
  const [selectedRows_WIG_Company, setSelectedRows_WIG_Company] = useState([]);

  // const handleOpenModal = () => setUpdateGenerateModal(true);

  const handleOpenModal = () => {
    // Reset states to false
    setWithoutEmail_GReport(false);
    setWithoutRfid_GReport(false);
    setWithoutCompany_GReport(false);
    setWithoutAccount_GReport(false);

    setUpdateGenerateModal(true); // Open the modal
  };
  const handleGenerateModal = () => setUpdateGenerateModal(false);
  // end GenerateModal
  const [expanded, setExpanded] = useState(false);
  const [UpdateEmailType, setUpdateEmailType] = useState("sync");
  const [admin_id, setadmin_id] = useState('');

  const [triggerReload, settriggerReload] = useState(false);

  // State management for the checkboxes
  const [withoutEmail_GReport, setWithoutEmail_GReport] = useState(false);
  const [withoutRfid_GReport, setWithoutRfid_GReport] = useState(false);
  const [withoutCompany_GReport, setWithoutCompany_GReport] = useState(false);
  const [withoutAccount_GReport, setWithoutAccount_GReport] = useState(false);
  const [openCheckedIgnoreModal, setopenCheckedIgnoreModal] = useState(false)
  const [openCheckedIgnoreModal_WAccount, setopenCheckedIgnoreModal_WAccount] = useState(false)
  const [openCheckedIgnoreModal_WRfid, setopenCheckedIgnoreModal_WRfid] = useState(false)
  const [openCheckedIgnoreModal_WCompany, setopenCheckedIgnoreModal_WCompany] = useState(false)
  const [openCheckedIgnoreModal_WIG_Email, setopenCheckedIgnoreModal_WIG_Email] = useState(false)
  const [openCheckedIgnoreModal_WIG_Account, setopenCheckedIgnoreModal_WIG_Account] = useState(false)
  const [openCheckedIgnoreModal_WIG_Rfid, setopenCheckedIgnoreModal_WIG_Rfid] = useState(false)
  const [openCheckedIgnoreModal_WIG_Company, setopenCheckedIgnoreModal_WIG_Company] = useState(false)

  const [isModalOpen_confDelete_W_Email, setisModalOpen_confDelete_W_Email] = useState(false);
  const [selectedCustomerForDelete_W_Email, setselectedCustomerForDelete_W_Email] = useState(null);

  const [openCheckedIgnoreModal_Report_MultipleDelete,setopenCheckedIgnoreModal_Report_MultipleDelete] = useState(false);

  const apiRoot_temp = process.env.REACT_APP_API_URL;
  const rowsPerPage = 15;
  const rowsPerPage_Account = 15;
  const rowsPerPage_Rfid = 15;
  const rowsPerPage_Company = 15;

  const rowsPerPage_IgnoreEmail = 6;

  // const style = {
  //   position: "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: 600,
  //   padding: "55px 30px",
  //   borderRadius: "10px",
  //   bgcolor: "background.paper",
  //   boxShadow: 24,
  // };



  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    // padding: '12px 12px',
    borderRadius: '10px',
    bgcolor: 'background.paper',
    boxShadow: 24,
  };

  const textFieldStyle = {
    borderRadius: '25px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '25px',
    },
  };

  const buttonStyle = {
    fontSize: '0.875rem', // Adjust button text size
    padding: '6px 12px', // Adjust button padding for smaller size
  };






  const handleEmailtypeRadioChange = (e) => {
    const option = e.target.value;
    setUpdateEmailType(option);
    setSelectedCompany("");
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedCompany(newValue === '4' ? '' : 3);
    setCurrentPage(1);
    setCurrentPage_Account(1);
    setCurrentPage_Rfid(1);
    setCurrentPage_Company(1)
    setSearchQuery("");
    setExpanded(false)
    setSelectedRows_WEmail([])
    setSelectedRows_WAccount([])
    setSelectedRows_WRfid([])
    setSelectedRows_WCompany([])
    setSelectedRows_WIG_Email([])
    setSelectedRows_WIG_Account([])
    setSelectedRows_WIG_Rfid([])
    setSelectedRows_WIG_Company([])
  };



  useEffect(() => {
    get('get_company_list_id').then(res => {
      const allOption = { company_id: '0001', company_name: 'All' };
      setCompanies([allOption, ...res.data.companies]);
      setCompaniesForModal(res.data.companies);
    })
      .catch(error => {
        console.error('Error fetching companies:', error);
      });
  }, [])



  const getCompanyNameById = useCallback((id) => {
    const company = companies.find(c => c.company_id === id);
    return company ? company.company_name : '';
  }, [companies]);



  const handleDownloadClick = () => {
    setdownload(true)
  }



  useEffect(() => {
    if (download === true) {
      const downloadReport = async () => {
        const r_type = { "1": "no_email", "2": "no_account", "3": "no_rfid", "4": "no_company" }
        const type_name = {
          "1": "without_email",
          "2": "without_account",
          "3": "without_rfid",
          "4": "without_company"
        }
        const report_type = r_type[value]
        const temp_comp = selectedCompany === '0001' ? 'all' : getCompanyNameById(selectedCompany)
        try {
          const response = await fetch(apiRoot_temp + `download_single_reports?company=${temp_comp}&report_type=${report_type}`);
          if (!response.ok) {
            throw new Error(`Failed to download report: ${response.statusText}`);
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `customers_${type_name[value]}_${temp_comp}_report.csv`); // Specify the filename
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } catch (error) {
          console.error('Error downloading the report:', error);
        } finally {
          // Reset the download state
          setdownload(false); // Assuming setDownload is your state setter
        }
      };
      // Trigger the download
      downloadReport();
    }
  }, [download]);


  // setting api of customers without account
  useEffect(() => {
    if (!selectedCompany || !companies.length) return;

    const companyName = getCompanyNameById(selectedCompany);
    if (!companyName) return;

    setIsLoading(true)
    const companyParam = selectedCompany === '0001' ? 'all' : getCompanyNameById(selectedCompany);
    get(`list_active_customers_without_account?company=${companyParam}`)
      .then((res) => {
        setwithoutAccountData(res.data);

        const withoutAccount_res = res.data;

        const temp_totalPages = Math.ceil(withoutAccount_res.length / rowsPerPage_Account);
        settotalPage_Account(temp_totalPages)
        setIsLoading(false)
      })
      .catch((error) => console.error('Error fetching customer data:', error));
  }, [selectedCompany, companies, getCompanyNameById, triggerReload]);




  // Fetch data based on selected company
  useEffect(() => {
    if (!selectedCompany || !companies.length) return;

    const companyName = getCompanyNameById(selectedCompany);

    if (!companyName) return;

    setIsLoading(true)
    const companyParam = selectedCompany === '0001' ? 'all' : getCompanyNameById(selectedCompany);;
    get(`list_active_customers_without_email?company=${companyParam}`)
      .then((res) => {
        setwithoutEmailData(res.data);
        const withoutEmail_res = res.data;

        const temp_totalPages = Math.ceil(withoutEmail_res.length / rowsPerPage);
        settotalPage(temp_totalPages)

        // const temp_totalPages_IgnoreEmail = Math.ceil(withoutEmail_res.length / rowsPerPage_IgnoreEmail);
        // settotalPage_ForIgnoreEmail(temp_totalPages_IgnoreEmail)

        setIsLoading(false)
      })
      .catch((error) => console.error('Error fetching customer data:', error));
  }, [selectedCompany, companies, getCompanyNameById, triggerReload]);


  //For Ignore Tab without Email
  useEffect(() => {
    if (!selectedCompany || !companies.length) return;

    const companyName = getCompanyNameById(selectedCompany);
    if (!companyName) return;

    setIsLoading(true);

    // Define the API endpoint based on the selected company
    const companyParam = selectedCompany === '0001' ? 'all' : selectedCompany;
    const ignoreCustomerApi = selectedCompany === '0001'
      ? 'listignorecustomer?without_email=true'
      : `listignorecustomer?without_email=true&company_id=${companyParam}`;

    get(ignoreCustomerApi).then((res) => {
      setwithoutEmailData_IgnoredTab(res.data.customers)
      const withoutEmail_res = res.data.customers;

      // const temp_totalPages = Math.ceil(withoutEmail_res.length / rowsPerPage);
      // settotalPage(temp_totalPages)

      const temp_totalPages_IgnoreEmail = Math.ceil(withoutEmail_res.length / rowsPerPage_IgnoreEmail);
      settotalPage_Email_ForIgnoreEmail(temp_totalPages_IgnoreEmail)

      setIsLoading(false)
    })
      .catch((error) => console.error('Error fetching customer data:', error));

  }, [selectedCompany, companies, getCompanyNameById, triggerReload])


  //For Ignore Tab without Account
  useEffect(() => {
    if (!selectedCompany || !companies.length) return;

    const companyName = getCompanyNameById(selectedCompany);
    if (!companyName) return;

    setIsLoading(true);

    // Define the API endpoint based on the selected company
    const companyParam = selectedCompany === '0001' ? 'all' : selectedCompany;
    const ignoreCustomerApi = selectedCompany === '0001'
      ? 'listignorecustomer?without_account=true'
      : `listignorecustomer?without_account=true&company_id=${companyParam}`;

    get(ignoreCustomerApi).then((res) => {
      setwithoutAccountData_IgnoreTab(res.data.customers)
      const withoutAccount_res = res.data.customers;

      const temp_totalPages = Math.ceil(withoutAccount_res.length / rowsPerPage_Account);
      settotalPage_Account_ForIgnoreAccount(temp_totalPages)
      setIsLoading(false)
    })
      .catch((error) => console.error('Error fetching customer data:', error));

  }, [selectedCompany, companies, getCompanyNameById, triggerReload])

  //For Ignore Tab without rfid
  useEffect(() => {
    if (!selectedCompany || !companies.length) return;

    const companyName = getCompanyNameById(selectedCompany);
    if (!companyName) return;

    setIsLoading(true);

    // Define the API endpoint based on the selected company
    const companyParam = selectedCompany === '0001' ? 'all' : selectedCompany;
    const ignoreCustomerApi = selectedCompany === '0001'
      ? `listignorecustomer?without_rfid=true`
      : `listignorecustomer?without_rfid=true&company_id=${companyParam}`;

    get(ignoreCustomerApi).then((res) => {
      setwithoutRfidtData_IgnoreTab(res.data.customers)
      const withoutRfid_res = res.data.customers;

      const temp_totalPages = Math.ceil(withoutRfid_res.length / rowsPerPage_Rfid);
      settotalPage_Rfid_ForIgnoreRfid(temp_totalPages)
      setIsLoading(false)
    })
      .catch((error) => console.error('Error fetching customer data:', error));

  }, [selectedCompany, companies, getCompanyNameById, triggerReload])

  //For Ignore Tab without Company
  useEffect(() => {
    setIsLoading(true)
    get(`listignorecustomer?without_company=true`)
      .then((res) => {
        setwithoutCompanyData_IgnoreTab(res.data.customers);
        const withoutCompany_res = res.data.customers;

        const temp_totalPages = Math.ceil(withoutCompany_res.length / rowsPerPage_Company);
        settotalPage_Company_ForIgnoreCompany(temp_totalPages)

        setIsLoading(false)
      })
      .catch((error) => console.error('Error fetching customer data:', error));
  }, [selectedCompany, getCompanyNameById, triggerReload]);


  // setting api of customers without rfid
  useEffect(() => {
    if (!selectedCompany || !companies.length) return;

    const companyName = getCompanyNameById(selectedCompany);
    if (!companyName) return;
    setIsLoading(true)
    const companyParam = selectedCompany === '0001' ? 'all' : getCompanyNameById(selectedCompany);;
    get(`list_active_customers_without_rfid?company=${companyParam}`)
      .then((res) => {
        setwithoutRfidData(res.data);
        const withoutRfid_res = res.data;

        const temp_totalPages = Math.ceil(withoutRfid_res.length / rowsPerPage_Rfid);
        settotalPage_Rfid(temp_totalPages)
        setIsLoading(false)
      })
      .catch((error) => console.error('Error fetching customer data:', error));
  }, [selectedCompany, companies, getCompanyNameById, triggerReload]);

  // setting api of customers without company
  useEffect(() => {
    setIsLoading(true)
    get(`list_active_customers_without_company`)
      .then((res) => {
        setwithoutCompanyData(res.data);
        const withoutCompany_res = res.data;

        const temp_totalPages = Math.ceil(withoutCompany_res.length / rowsPerPage_Company);
        settotalPage_Company(temp_totalPages)
        setIsLoading(false)
      })
      .catch((error) => console.error('Error fetching customer data:', error));
  }, [selectedCompany, getCompanyNameById, triggerReload]);


  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
    setCurrentPage(1);
    setCurrentPage_Account(1);
    setCurrentPage_Rfid(1);
    setSearchQuery("");
  };

  // For pagination Ignore tab1 
  const handleNextPage_IgnoreEmail = () => {
    if (currentPage_IgnoreEmail < totalPage_ForIgnoreEmail) {
      setCurrentPage_IgnoreEmail(currentPage_IgnoreEmail + 1);
    }
  };

  const handlePreviousPage_IgnoreEmail = () => {
    if (currentPage_IgnoreEmail > 1) {
      setCurrentPage_IgnoreEmail(currentPage_IgnoreEmail - 1);
    }
  };

  // For pagination tab1 
  const handleNextPage = () => {
    console.log("Next clicked!!!");
    console.log("current page vallue::",currentPage);
    console.log("total page value::",totalPage);
    
    
    if (currentPage < totalPage) {
      setCurrentPage(currentPage + 1);
      console.log("current page vallue::",currentPage);
      
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // For pagination tab2 
  const handleNextPage_Account = () => {
    if (currentPage_Account < totalPage_Account) {
      setCurrentPage_Account(currentPage_Account + 1);
    }
  };

  const handlePreviousPage_Account = () => {
    if (currentPage_Account > 1) {
      setCurrentPage_Account(currentPage_Account - 1);
    }
  };

  // For pagination tab3
  const handleNextPage_Rfid = () => {
    if (currentPage_Rfid < totalPage_Rfid) {
      setCurrentPage_Rfid(currentPage_Rfid + 1);
    }
  };

  const handlePreviousPage_Rfid = () => {
    if (currentPage_Rfid > 1) {
      setCurrentPage_Rfid(currentPage_Rfid - 1);
    }
  };

  // For pagination tab4
  const handleNextPage_Company = () => {
    if (currentPage_Company < totalPage_Company) {
      setCurrentPage_Company(currentPage_Company + 1);
    }
  };

  const handlePreviousPage_Company = () => {
    if (currentPage_Company > 1) {
      setCurrentPage_Company(currentPage_Company - 1);
    }
  };

  // useEffect(() => {
  //   const temp_totalPages = Math.ceil(withoutEmailData.length / rowsPerPage);
  //   settotalPage(temp_totalPages)
  // }, [withoutEmailData]);

  const UpdateEmail = (customer_id, firstName, lastName) => {
    setselectedCustomerIdFromUpdateEmail(customer_id);
    setselectedCustomerLNameFromUpdateEmail(lastName);
    setselectedCustomerFNameFromUpdateEmail(firstName);
    triggerUpdateEmailModal(true)
  }

  const handleSendFlash = (event) => {
    event.preventDefault();
    const sendFlash_api = "send_flash"
    if (flashAccountCustomerId !== null) {
      const data = {
        customer_id: flashAccountCustomerId
      }
      post(sendFlash_api, data)
        .then((response) => {
          if (response.status === 200) {
            console.log(response)
            toast.success(response.data.message, {
              autoClose: 500,
            });
            triggerUpdateEmailModal(false);
          } else {
            toast.error(`Error: ${response.statusText}`, {
              autoClose: 500,
            });
          }
        })
        .catch((error) => {
          console.error("Delete Error:", error);
          toast.error(`Error: ${error.message || error}`, {
            autoClose: 500,
          });
        });
    }

    triggerUpdateEmailModal(false);
    setflashAccountCustomerId(null);

  }

  const handleCloseUpdateEmail = () => {
    triggerUpdateEmailModal(false)
  }

  const OpenFlashAccountModal = (customer_id) => {
    triggerFlashAccountModal(true)
    setflashAccountCustomerId(customer_id)
  }


  const handleCloseUpdateAccount = () => {
    triggerFlashAccountModal(false)
    setflashAccountCustomerId(null)
  }

  const OpenRfidModal = (customerId, customerEmail) => {
    setcustomerIdForUpdateRfid(customerId)
    setemailForUpdateRfid(customerEmail)
    triggerRfidModal(true)
  }

  const handleCloseRfid = () => {
    triggerRfidModal(false)
  }

  const handleSubmitRfid = (e) => {
    e.preventDefault();
    const rfid_api = "rfid_action_report"
    const data = {
      email: emailForUpdateRfid,
      customer_id: customerIdForUpdateRfid,
      facilitycode: facilityCode,
      card_id: cardId,
    };

    post(rfid_api, data)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Rfid updated successfully!", { autoClose: 1500 });
          triggerRfidModal(false)
          window.location.reload();
        } else {
          toast.error(`Error: ${response.statusText}`, { autoClose: 1500 });
        }
      })
      .catch((error) => {
        console.error("Rfid Updation Error:", error);
        toast.error(`Error: ${error.message || error}`, { autoClose: 1500 });
      });

  }

  const OpenCompanyModal = (customer_id) => {
    setSelectedCustomerId(customer_id); // Store the customer ID
    triggerCompanyModal(true)
  }

  const CloseCompanyModal = () => {
    triggerCompanyModal(false)
  }

  const CompanyChange_Modal = (company) => {
    console.log(company)
    setselectedCompanyForModal(company)
  }

  const handleUpdateCompany = (event) => {
    event.preventDefault();

    const updateCompanyApi = "update_customer_company"

    const selectedCompany = companies_formodals.find(company => company.company_id === selectedCompanyForModal);

    if (selectedCustomerId && selectedCompany) {
      const data = {
        customer_id: selectedCustomerId,
        company_name: selectedCompany.company_name, // Get the company name based on the selected ID
      };

      post(updateCompanyApi, data)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Company updated successfully!", { autoClose: 1500 });
            CloseCompanyModal();
            window.location.reload();
          } else {
            toast.error(`Error: ${response.statusText}`, { autoClose: 1500 });
          }
        })
        .catch((error) => {
          console.error("Update Company Error:", error);
          toast.error(`Error: ${error.message || error}`, { autoClose: 1500 });
        });
    }

  }

  const handleSubmitEmail = (event) => {
    event.preventDefault();

    const updateEmailApi = "email_action_report";
    const updatelocalEmailApi = "update_customer_email_credential";

    const data = {
      email: emailModalData, // Use the entered email
      customer_id: selectedCustomerIdFromUpdateEmail, // Use the stored customer ID
      first_name: selectedCustomerFNameFromUpdateEmail,
      last_name: selectedCustomerLNameFromUpdateEmail
    };

    if (UpdateEmailType == "sync") {
      post(updateEmailApi, data)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Email updated successfully!", { autoClose: 1500 });
            handleCloseUpdateEmail(); // Close the modal
          } else {
            toast.error(`Error: ${response.msg}`, { autoClose: 1500 });
          }
        })
        .catch((error) => {
          console.error("Update Email Error:", error);
          toast.error(`Error: ${error.message || error}`, { autoClose: 1500 });
        });
    }
    else if (UpdateEmailType == "local") {
      post(updatelocalEmailApi, data)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Email updated successfully!", { autoClose: 1500 });
            handleCloseUpdateEmail(); // Close the modal
          } else {
            toast.error(`Error: ${response.msg}`, { autoClose: 1500 });
          }
        })
        .catch((error) => {
          console.error("Update Email Error:", error);
          toast.error(`Error: ${error.message || error}`, { autoClose: 1500 });
        });
    }
    else {
      toast.error(`Error: Choose type first`, { autoClose: 1500 });
    }
  };


  const handleCardIdChange = (e) => {
    const newCardId = e.target.value;
    if (newCardId <= 65535) {
      setcardId(newCardId);
      const rfidcombined = facilityCode.concat(":").concat(newCardId);
      setRfid(rfidcombined);
    }
    else {
      toast.error("Error .. Card Id must be 0 - 65535 range", {
        autoClose: 3000,
      })
    }

  }

  const handlefacilityChange = (e) => {
    const newFacilityCode = e.target.value;
    if (newFacilityCode <= 255) {
      setfacilityCode(newFacilityCode);
      const rfidcombined = newFacilityCode.concat(":").concat(cardId);
      setRfid(rfidcombined);
    }
    else {
      toast.error("Error .. Facillity code must be 0 - 255 range", {
        autoClose: 3000,
      })
    }

  }

  // Handle expand/collapse
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setSelectedRows_WIG_Email([])
    setSelectedRows_WIG_Account([])
    setSelectedRows_WIG_Rfid([])
    setSelectedRows_WIG_Company([])
  };

  useEffect(() => {
    var mcdata = JSON.parse(localStorage.getItem("MCData"));
    var tempadmin_id = mcdata.admin_id
    setadmin_id(tempadmin_id)
  }, []);

  const handleWEmailRedoFunction = (customer_id, company_id, ignore_type) => {
    
    const withoutEmail_redo_api = "ignoreredo";
    const data = {
      customer_id: customer_id,
      ignore_type: ignore_type,
      admin_id: admin_id,
      company_id: company_id

    }

    post(withoutEmail_redo_api, data)
      .then((response) => {
        if (response.status === 200) {
          console.log("Redo Response:", response);
          toast.error(response.data.message, {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Redo Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  const handleWAccountRedoFunction = (customer_id, company_id, ignore_type) => {
    const withoutAccount_redo_api = "ignoreredo";
    const data = {
      customer_id: customer_id,
      ignore_type: ignore_type,
      admin_id: admin_id,
      company_id: company_id

    }

    post(withoutAccount_redo_api, data)
      .then((response) => {
        if (response.status === 200) {
          console.log("Redo Response:", response);
          toast.error(response.data.message, {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Redo Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  const handleWRfidRedoFunction = (customer_id, company_id, ignore_type) => {

    const withoutRfid_redo_api = "ignoreredo";
    const data = {
      customer_id: customer_id,
      ignore_type: ignore_type,
      admin_id: admin_id,
      company_id: company_id

    }

    post(withoutRfid_redo_api, data)
      .then((response) => {
        if (response.status === 200) {
          console.log("Redo Response:", response);
          toast.error(response.data.message, {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Redo Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  const handleWCompanyRedoFunction = (customer_id, ignore_type) => {

    const withoutCompany_redo_api = "ignoreredo";
    const data = {
      customer_id: customer_id,
      ignore_type: ignore_type,
      admin_id: admin_id
    }

    post(withoutCompany_redo_api, data)
      .then((response) => {
        if (response.status === 200) {
          console.log("Redo Response:", response);
          toast.error(response.data.message, {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Redo Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  const handleWEmailIgnoreFunction = (customer_id, company_id, ignore_type) => {

    const withoutEmail_ignore_api = "ignoreCustomer";
    // const data ={
    //   customer_id :customer_id,
    //   ignore_type: ignore_type,
    //   admin_id:admin_id,
    //   company_id: company_id

    // }
    if (company_id !== "N/A") {
      var data = {
        customer_id: customer_id,
        ignore_type: ignore_type,
        admin_id: admin_id,
        company_id: company_id
      }
    } else {
      var data = {
        customer_id: customer_id,
        ignore_type: ignore_type,
        admin_id: admin_id
      }
    }

    post(withoutEmail_ignore_api, data)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Customer ignored", {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Ignore Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  const handleWAccountIgnoreFunction = (customer_id, company_id, ignore_type) => {

    const withoutAccount_ignore_api = "ignoreCustomer";
    // const data ={
    //   customer_id :customer_id,
    //   ignore_type: ignore_type,
    //   admin_id:admin_id,
    //   company_id: company_id

    // }

    if (company_id !== "N/A") {
      var data = {
        customer_id: customer_id,
        ignore_type: ignore_type,
        admin_id: admin_id,
        company_id: company_id
      }
    } else {
      var data = {
        customer_id: customer_id,
        ignore_type: ignore_type,
        admin_id: admin_id
      }
    }

    post(withoutAccount_ignore_api, data)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Customer ignored", {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Ignore Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  const handleWRfidIgnoreFunction = (customer_id, company_id, ignore_type) => {

    const withoutRfid_ignore_api = "ignoreCustomer";

    if (company_id !== "N/A") {
      var data = {
        customer_id: customer_id,
        ignore_type: ignore_type,
        admin_id: admin_id,
        company_id: company_id
      }
    } else {
      var data = {
        customer_id: customer_id,
        ignore_type: ignore_type,
        admin_id: admin_id
      }
    }

    post(withoutRfid_ignore_api, data)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Customer ignored", {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Ignore Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  const handleWCompanyIgnoreFunction = (customer_id, ignore_type) => {

    const withoutCompany_ignore_api = "ignoreCustomer";
    const data = {
      customer_id: customer_id,
      ignore_type: ignore_type,
      admin_id: admin_id

    }

    post(withoutCompany_ignore_api, data)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Selected customers were successfully ignored.", {
            autoClose: 500,
          });
          setopenCheckedIgnoreModal(false); // Close the modal after success
          setSelectedRows_WEmail([]); // Clear selected rows after submission
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Ignore Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });

  }

  // const handleSubmit_GReport = (event) => {
  //   event.preventDefault(); // Prevent the default form submission

  //   const apiEndpoint = "download_generate_reports";
  //   const data = {
  //     without_email: withoutEmail_GReport,
  //     without_rfid: withoutRfid_GReport,
  //     without_company: withoutCompany_GReport,
  //     without_account: withoutAccount_GReport,
  //     company_name: getCompanyNameById(selectedCompany),
  //   };
  //   console.log(data,"Data")

  //   // Replace `post` with your actual API call function
  //   post(apiEndpoint, data)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         toast.success("Report generated successfully!", {
  //           autoClose: 500,
  //         });
  //       } else {
  //         toast.error(`Error: ${response.statusText}`, {
  //           autoClose: 500,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       toast.error(`Error: ${error.message || error}`, {
  //         autoClose: 500,
  //       });
  //     });

  //   handleGenerateModal(); // Close the modal after submission
  // };

  const handleSubmit_GReport = async (event) => {
    event.preventDefault();
    handleGenerateModal();
    const apiEndpoint = "download_generate_reports";
    const data = {
        without_email: withoutEmail_GReport,
        without_rfid: withoutRfid_GReport,
        without_company: withoutCompany_GReport,
        without_account: withoutAccount_GReport,
        company_name: getCompanyNameById(selectedCompany),
    };

    try {
        // Make a POST request to the API with responseType 'blob'
        const downloadResponse = await postzip(apiEndpoint, data,  {
          responseType: 'blob', // Important to set the response type
          headers: {
            'Accept': 'application/zip', // Set the accept header
          },
        });

        if (downloadResponse.status === 200) {
            console.log("downloadResponse Success");

            
            const url = window.URL.createObjectURL(new Blob([downloadResponse.data]));
            const link = document.createElement('a');
            link.href = url;
            // Set a dynamic filename with a timestamp
            const currentDate = new Date();
            const formattedDate = currentDate.toISOString().replace(/[:.]/g, '_');
            const filename = `customers_report_${formattedDate}.zip`;
            link.download = filename;

            // Append the link to the body, trigger the download, and remove the link
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Revoke the object URL to free up memory
            window.URL.revokeObjectURL(url);

            toast.success("Report generated successfully!", {
                autoClose: 500,
            });
        } else {
            toast.error(`Error: ${downloadResponse.statusText}`, {
                autoClose: 500,
            });
        }
    } catch (error) {
        console.error("Error during file download:", error);
        toast.error(`Error: ${error.message || error}`, {
            autoClose: 500,
        });
    } finally {
        handleGenerateModal(); // Close the modal after submission
    }
};



  // Function to handle checkbox changes
  const handleCheckboxChangeWEmail = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_WEmail([...selectedRows_WEmail, customerId]); // Add selected customer_id
    } else {
      setSelectedRows_WEmail(selectedRows_WEmail.filter(id => id !== customerId)); // Remove deselected customer_id
    }

  };

  const handleDeleteReport_W_Email = (event,customerToDelete)=>{
    event.preventDefault();
    setselectedCustomerForDelete_W_Email(customerToDelete)
    setisModalOpen_confDelete_W_Email(true)
  }

  // Function to handle checkbox changes w/o Account
  const handleCheckboxChangeWAccount = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_WAccount([...selectedRows_WAccount, customerId]); // Add selected customer_id
    } else {
      setSelectedRows_WAccount(selectedRows_WAccount.filter(id => id !== customerId)); // Remove deselected customer_id
    }

  };

  // Function to handle checkbox changes w/o Rfid
  const handleCheckboxChangeWRfid = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_WRfid([...selectedRows_WRfid, customerId]); // Add selected customer_id
    } else {
      setSelectedRows_WRfid(selectedRows_WRfid.filter(id => id !== customerId)); // Remove deselected customer_id
    }

  };

    // Function to handle checkbox changes w/o Company
    const handleCheckboxChangeWCompany = (event, customerId) => {
      const isChecked = event.target.checked;
  
      if (isChecked) {
        setSelectedRows_WCompany([...selectedRows_WCompany, customerId]); // Add selected customer_id
      } else {
        setSelectedRows_WCompany(selectedRows_WCompany.filter(id => id !== customerId)); // Remove deselected customer_id
      }
  
    };

     // Function to handle checkbox changes w/o Ignored Email
     const handleCheckboxChangeWIG_Email = (event, customerId) => {
      const isChecked = event.target.checked;
  
      if (isChecked) {
        setSelectedRows_WIG_Email([...selectedRows_WIG_Email, customerId]); // Add selected customer_id
      } else {
        setSelectedRows_WIG_Email(selectedRows_WIG_Email.filter(id => id !== customerId)); // Remove deselected customer_id
      }
  
    };

     // Function to handle checkbox changes w/o Ignored Account Redo
     const handleCheckboxChangeWIG_Account = (event, customerId) => {
      const isChecked = event.target.checked;
  
      if (isChecked) {
        setSelectedRows_WIG_Account([...selectedRows_WIG_Account, customerId]); // Add selected customer_id
      } else {
        setSelectedRows_WIG_Account(selectedRows_WIG_Account.filter(id => id !== customerId)); // Remove deselected customer_id
      }
  
    };

     // Function to handle checkbox changes w/o Ignored Rfid Redo
     const handleCheckboxChangeWIG_Rfid = (event, customerId) => {
      const isChecked = event.target.checked;
  
      if (isChecked) {
        setSelectedRows_WIG_Rfid([...selectedRows_WIG_Rfid, customerId]); // Add selected customer_id
      } else {
        setSelectedRows_WIG_Rfid(selectedRows_WIG_Rfid.filter(id => id !== customerId)); // Remove deselected customer_id
      }
  
    };

        // Function to handle checkbox changes w/o Ignored Rfid Redo
        const handleCheckboxChangeWIG_Company = (event, customerId) => {
        const isChecked = event.target.checked;
    
        if (isChecked) {
          setSelectedRows_WIG_Company([...selectedRows_WIG_Company, customerId]); // Add selected customer_id
        } else {
          setSelectedRows_WIG_Company(selectedRows_WIG_Company.filter(id => id !== customerId)); // Remove deselected customer_id
        }
    
      };

  const handleCheckedData_WEmail = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal(true)

  }

  const handleCheckedData_WAccount = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_WAccount(true)

  }

  const handleCheckedData_WRfid = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_WRfid(true)

  }

  const handleCheckedData_WCompany = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_WCompany(true)

  }

  const handleCheckedData_WIG_Email = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_WIG_Email(true)

  }

  const handleCheckedData_WIG_Account = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_WIG_Account(true)

  }

  const handleCheckedData_WIG_Rfid = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_WIG_Rfid(true)

  }

  const handleCheckedData_WIG_Company = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_WIG_Company(true)

  }



  const handleCheckedIgnoreClose = () => {
    setopenCheckedIgnoreModal(false)
  }

  const handleCheckedIgnoreClose_WAccount = () => {
    setopenCheckedIgnoreModal_WAccount(false)
  }

  const handleCheckedIgnoreClose_WRfid = () => {
    setopenCheckedIgnoreModal_WRfid(false)
  }

  const handleCheckedIgnoreClose_WCompany = () => {
    setopenCheckedIgnoreModal_WCompany(false)
  }

  
  const handleCheckedIgnoreClose_WIG_Email = () => {
    setopenCheckedIgnoreModal_WIG_Email(false)
  }

  const handleCheckedIgnoreClose_WIG_Account = () => {
    setopenCheckedIgnoreModal_WIG_Account(false)
  }

  const handleCheckedIgnoreClose_WIG_Rfid = () => {
    setopenCheckedIgnoreModal_WIG_Rfid(false)
  }

  const handleCheckedIgnoreClose_WIG_Company = () => {
    setopenCheckedIgnoreModal_WIG_Company(false)
  }

  const handleDeleteModalClose_W_Email = () =>{
    setisModalOpen_confDelete_W_Email(false)
  }

  // Without Email Checked Ignore
  const handleChecked_WEmailIgnoreSubmit = (event) => {
    event.preventDefault();
    handleMultipleIgnoreSubmit(selectedRows_WEmail, "without_email");
  };

  // Without Account Checked Ignore
  const handleChecked_WAccountIgnoreSubmit = (event) => {
    event.preventDefault();
    handleMultipleIgnoreSubmit(selectedRows_WAccount, "without_account");
  };

  // Without Rfid Checked Ignore
  const handleChecked_WRfidIgnoreSubmit = (event) => {
    event.preventDefault();
    handleMultipleIgnoreSubmit(selectedRows_WRfid, "without_rfid");
  };
  

    // Without Company Checked Ignore
    const handleChecked_WCompanyIgnoreSubmit = (event) => {
      event.preventDefault();
      handleMultipleIgnoreSubmit(selectedRows_WCompany, "without_company");
    };
    
   
     const handleChecked_WIGEmailIgnoreSubmit = (event) => {
      event.preventDefault();
      handleMultipleRedoSubmit(selectedRows_WIG_Email, "without_email");
     }

     const handleChecked_WIGAccountIgnoreSubmit = (event) => {
      event.preventDefault();
      handleMultipleRedoSubmit(selectedRows_WIG_Account, "without_account");
     }

     const handleChecked_WIGRfidIgnoreSubmit = (event) => {
      event.preventDefault();
      handleMultipleRedoSubmit(selectedRows_WIG_Rfid, "without_rfid");
     }

     const handleChecked_WIGCompanyIgnoreSubmit = (event) => {
      event.preventDefault();
      handleMultipleRedoSubmit(selectedRows_WIG_Company, "without_company");
     }
  


  // const handleMultipleIgnoreSubmit = async (event) => {
  const handleMultipleIgnoreSubmit = async (selectedRows, ignoreType) => {
    let selectedCustomerData = [];
    let requestData = {};

    if (ignoreType === "without_email") {
      // Filter the selected customer data from withoutEmailData
      // const selectedCustomerData = selectedRows_WEmail.map((customerId) => {
      selectedCustomerData = selectedRows.map((customerId) => {
        // Find the customer data object from withoutEmailData using customerId
        const customerData = withoutEmailData.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null; // Handle case where customer data is not found
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType, // Assuming 'without_rfid' for all, update if needed
          admin_id: admin_id, // Replace with dynamic admin_id if required
          company_id: customerData.company_id, // Correctly access company_id
        };
      }).filter(Boolean); // Remove any null entries
    }

    if (ignoreType === "without_account") {
      // Filter the selected customer data from withoutEmailData
      // const selectedCustomerData = selectedRows_WEmail.map((customerId) => {
      selectedCustomerData = selectedRows.map((customerId) => {
        // Find the customer data object from withoutEmailData using customerId
        const customerData = withoutAccountData.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null; // Handle case where customer data is not found
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType, // Assuming 'without_rfid' for all, update if needed
          admin_id: admin_id, // Replace with dynamic admin_id if required
          company_id: customerData.company_id, // Correctly access company_id
        };
      }).filter(Boolean); // Remove any null entries
    }

    if (ignoreType === "without_rfid") {
      selectedCustomerData = selectedRows.map((customerId) => {
        // Find the customer data object from withoutEmailData using customerId
        const customerData = withoutRfidData.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null;
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType,
          admin_id: admin_id,
          company_id: customerData.company_id,
        };
      }).filter(Boolean); // Remove any null entries
    }

    if (ignoreType === "without_company") {
      selectedCustomerData = selectedRows.map((customerId) => {
        // Find the customer data object from withoutEmailData using customerId
        const customerData = withoutCompanyData.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null;
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType,
          admin_id: admin_id
        };
      }).filter(Boolean); // Remove any null entries
    }

    if (selectedCustomerData.length === 0) {
      toast.error("No valid customer data found.");
      return;
    }

    // Prepare the request payload in the required structure
    // if (ignoreType !== "without_company"){
    requestData = {
      customer_ids: selectedCustomerData.map((item) => item.customer_id),
      ignore_types: Array(selectedCustomerData.length).fill(ignoreType),
      admin_ids: Array(selectedCustomerData.length).fill(admin_id),
      company_ids: selectedCustomerData.map((item) => item.company_id),
    };
  // }else{
  //   requestData = {
  //     customer_ids: selectedCustomerData.map((item) => item.customer_id),
  //     ignore_types: Array(selectedCustomerData.length).fill(ignoreType),
  //     admin_ids: Array(selectedCustomerData.length).fill(admin_id)
  //   };
  // }

    try {
      const response = await post('multipleignorecustomer', requestData);

      if (response.status === 200) {
        toast.success("Selected customers were successfully ignored.");
        if (ignoreType === "without_email") {
          setopenCheckedIgnoreModal(false);
          setSelectedRows_WEmail([]);
        }
        else if (ignoreType === "without_account") {
          setopenCheckedIgnoreModal_WAccount(false)
          setSelectedRows_WAccount([])
        }
        else if (ignoreType === "without_rfid") {
          setopenCheckedIgnoreModal_WRfid(false)
          setSelectedRows_WRfid([])
        }
        else if (ignoreType === "without_company") {
          setopenCheckedIgnoreModal_WCompany(false)
          setSelectedRows_WCompany([])
        }
        settriggerReload(!triggerReload);
        return; // Exit function after successful response
      }
      else {
        toast.error("An error occurred while ignoring the customers. Please try again.");
      }

    } catch (error) {
      console.error("Error while ignoring customers:", error);
      toast.error("An error occurred while processing your request.");
    }
  }
  //  Function for multiple ignore for w/o Email Ends

  // Function for multiple ignore for w/o Email For Redo
  const handleMultipleRedoSubmit = async  (selectedRows, ignoreType) => {
    let selectedCustomerData = [];
    let requestData = {};

    if (ignoreType === "without_email") {
      selectedCustomerData = selectedRows.map((customerId) => {
        const customerData = withoutEmailData_IgnoredTab.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null; 
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType, // Assuming 'without_rfid' for all, update if needed
          admin_id: admin_id, // Replace with dynamic admin_id if required
          company_id: customerData.company_id, // Correctly access company_id
        };
      }).filter(Boolean); // Remove any null entries
    }

    if (ignoreType === "without_account") {
      selectedCustomerData = selectedRows.map((customerId) => {
        const customerData = withoutAccountData_IgnoreTab.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null; 
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType, // Assuming 'without_rfid' for all, update if needed
          admin_id: admin_id, // Replace with dynamic admin_id if required
          company_id: customerData.company_id, // Correctly access company_id
        };
      }).filter(Boolean); // Remove any null entries
    }

    if (ignoreType === "without_rfid") {
      selectedCustomerData = selectedRows.map((customerId) => {
        const customerData = withoutRfidData_IgnoreTab.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null; 
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType, // Assuming 'without_rfid' for all, update if needed
          admin_id: admin_id, // Replace with dynamic admin_id if required
          company_id: customerData.company_id, // Correctly access company_id
        };
      }).filter(Boolean); // Remove any null entries
    }

    if (ignoreType === "without_company") {
      selectedCustomerData = selectedRows.map((customerId) => {
        const customerData = withoutCompanyData_IgnoreTab.find(
          (customer) => customer.customer_id === customerId
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${customerId}`);
          return null; 
        }

        return {
          customer_id: customerData.customer_id,
          ignore_type: ignoreType, // Assuming 'without_rfid' for all, update if needed
          admin_id: admin_id, // Replace with dynamic admin_id if required
          company_id: customerData.company_id, // Correctly access company_id
        };
      }).filter(Boolean); // Remove any null entries
    }
    
    if (selectedCustomerData.length === 0) {
      toast.error("No valid customer data found.");
      return;
    }

    // Prepare the request payload in the required structure
    
    requestData = {
      customer_ids: selectedCustomerData.map((item) => item.customer_id),
      ignore_types: Array(selectedCustomerData.length).fill(ignoreType),
      admin_ids: Array(selectedCustomerData.length).fill(admin_id),
      company_ids: selectedCustomerData.map((item) => item.company_id),
    };

    try {
      const response = await post('multipleignoreredocustomer', requestData);

      if (response.status === 200) {
        toast.success("Selected customers were successfully Redo.");
        if (ignoreType === "without_email") {
          setopenCheckedIgnoreModal_WIG_Email(false);
          setSelectedRows_WIG_Email([]);
        }
        else if (ignoreType === "without_account") {
          setopenCheckedIgnoreModal_WIG_Account(false);
          setSelectedRows_WIG_Account([]);
        }
        else if (ignoreType === "without_rfid") {
          setopenCheckedIgnoreModal_WIG_Rfid(false);
          setSelectedRows_WIG_Rfid([]);
        }
        else if (ignoreType === "without_company") {
          setopenCheckedIgnoreModal_WIG_Company(false);
          setSelectedRows_WIG_Company([]);
        }
       
        settriggerReload(!triggerReload);
        return; // Exit function after successful response
      }
      else {
        toast.error("An error occurred while Redo the customers. Please try again.");
      }

    } catch (error) {
      console.error("Error while Redo customers:", error);
      toast.error("An error occurred while processing your request.");
    }
    
  }

  const handleDelete_W_Email = (event) =>{
    event.preventDefault();
    if (selectedCustomerForDelete_W_Email)
    {
      const data = {
        customer_id: selectedCustomerForDelete_W_Email.customer_id,
        tp_id: selectedCustomerForDelete_W_Email.tp_id,
        admin_id: admin_id, 
        tp_credentialid: selectedCustomerForDelete_W_Email.tp_credentialid,
        tp_groupid: selectedCustomerForDelete_W_Email.tp_groupid,
      };

      console.log("Data of multiple delete on reports::",data);
      

      post("delete_customerdata", data)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Customer Deleted Successfully!", {
            autoClose: 500,
          });

          settriggerReload(!triggerReload); // Trigger reload after successful delete
          return; // Exit the function after a successful response
        } else {
          toast.error("An error occurred while deleting the customer. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error while deleting the customer:", error);
        toast.error("An error occurred while processing your request.");
      });

    }
    
    
  }

  const handleCheckedData_Report_MultipleDelete = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_Report_MultipleDelete(true)
  }

  const handleDeleteModalClose_Report_MultipleDelete = (event) =>{
    setopenCheckedIgnoreModal_Report_MultipleDelete(false);
  }


  // Calculate start and end index for the current page w/o Email
  const startIndex_Pagination = (currentPage - 1) * rowsPerPage + 1;
  const endIndex_Pagination = Math.min(currentPage * rowsPerPage, withoutEmailData.length);

  // Calculate start and end index for the current page of W/o Account
  const startIndex_Pagination_Account = (currentPage_Account - 1) * rowsPerPage_Account + 1;
  const endIndex_Pagination_Account = Math.min(currentPage_Account * rowsPerPage_Account, withoutAccountData.length);

  // Calculate start and end index for the current page of W/o Rfid
  const startIndex_Pagination_Rfid = (currentPage_Rfid - 1) * rowsPerPage_Rfid + 1;
  const endIndex_Pagination_Rfid = Math.min(currentPage_Rfid * rowsPerPage_Rfid, withoutRfidData.length);

  // Calculate start and end index for the current page of W/o Rfid
  const startIndex_Pagination_Company = (currentPage_Company - 1) * rowsPerPage_Company + 1;
  const endIndex_Pagination_Company = Math.min(currentPage_Company * rowsPerPage_Company, withoutCompanyData.length);

  // Calculate start and end index for the current page w/o Email ----> Ignore Tab
  const startIndex_W_EmailPagination_Ignore = (currentPage - 1) * rowsPerPage + 1;
  const endIndex_W_EmailPagination_Pagination_Ignore = Math.min(currentPage * rowsPerPage, withoutEmailData_IgnoredTab.length);

  // Calculate start and end index for the current page w/o Account ----> Ignore Tab
  const startIndex_W_AccountPagination_Account = (currentPage_Account - 1) * rowsPerPage_Account + 1;
  const endIndex_W_AccountPaginationPagination_Account = Math.min(currentPage_Account * rowsPerPage_Account, withoutAccountData_IgnoreTab.length);

  // Calculate start and end index for the current page of W/o Rfid ------> Ignore Tab
  const startIndex_W_Pagination_Rfid_Ignore = (currentPage_Rfid - 1) * rowsPerPage_Rfid + 1;
  const endIndex_W_Pagination_Rfid_Ignore = Math.min(currentPage_Rfid * rowsPerPage_Rfid, withoutRfidData_IgnoreTab.length);

  // Calculate start and end index for the current page of W/o Rfid ------> Ignore Tab
  const startIndex_W_Pagination_Company_Ignore = (currentPage_Account - 1) * rowsPerPage_Company + 1;
  const endIndex_W_Pagination_Company_Ignore = Math.min(currentPage_Account * rowsPerPage_Company, withoutCompanyData_IgnoreTab.length);



  return (
    <React.Fragment>
      <ToastContainer />
      <Box sx={{ display: "flex" }}>
        <Sidebar />

        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <div className="App">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h3 className="heading-style" style={{
                fontSize: '1.5rem',
                fontWeight: '500'
              }}>REPORTS</h3>
              <div className="d-flex align-items-center">
                <Button
                  className="btn-sty text-capitalize"
                  variant="contained"
                  onClick={handleOpenModal}
                >
                  Generate Report
                </Button>
              </div>
            </div>
          </div>
          <div style={{ background: '#fff', padding: '12px 10px', borderRadius: '15px' }}>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange} aria-label="lab API tabs example">
                    <Tab
                      label="Customers Without Email" value="1" />
                    <Tab

                      label="Customers Without Account" value="2" />
                    <Tab

                      label="Customers Without RFID" value="3" />
                    <Tab

                      label="Customers Without Company" value="4" />

                    <Tab

                      label="CUSTOMERS IGNORED" value="5" />
                  </TabList>
                </Box>

                {isLoading ? (
                  <div
                    className="table-style"
                    style={{ marginLeft: "46%", marginTop: "20%" }}
                  >
                    <PulseLoader
                      color="#02487B"
                      height={29}
                      margin={4}
                      radius={24}
                      width={4}
                    />
                    <p style={{ fontWeight: "bold", color: "#02487B" }}>
                      Loading
                    </p>
                  </div>
                ) : (
                  <>

                    {/* Container for heading and search */}
                    <div className="d-flex align-items-center justify-content-between mt-4" style={{ padding: '0 24px' }}>
                      <h5 className="heading-style mb-0" style={{ fontSize: '27px', fontWeight: '500' }}>
                        {/* {getCompanyNameById(selectedCompany) || 'All Companies'} */}
                        {value === '4' ? '' : (getCompanyNameById(selectedCompany) || 'All Companies')}
                      </h5>

                      <div className="d-flex align-items-center ms-auto">
                        {/* <TextField
                          label="Search"
                          variant="outlined"
                          size="small"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          sx={{ marginBottom: '1rem' }}
                        /> */}

                        {/* Conditionally render the button */}
                        {selectedRows_WEmail.length > 1 && (
                          <Button className="reports-ignore-btns me-4" variant="outlined" onClick={handleCheckedData_WEmail}>Ignore</Button>
                        )}
                        {selectedRows_WAccount.length > 1 && (
                          <Button className="reports-ignore-btns me-4" variant="outlined" onClick={handleCheckedData_WAccount}>Ignore</Button>
                        )}
                        {selectedRows_WRfid.length > 1 && (
                          <Button className="reports-ignore-btns me-4" variant="outlined" onClick={handleCheckedData_WRfid}>Ignore</Button>
                        )}
                        {selectedRows_WCompany.length > 1 && (
                          <Button className="reports-ignore-btns me-4" variant="outlined" onClick={handleCheckedData_WCompany}>Ignore</Button>
                        )}
                        {selectedRows_WIG_Email.length > 1 && (
                        <Button className="reports-ignoreRedo-btns me-4" variant="outlined" onClick={handleCheckedData_WIG_Email}>Redo</Button>
                      )}
                      {selectedRows_WIG_Account.length > 1 && (
                        <Button className="reports-ignoreRedo-btns me-4" variant="outlined" onClick={handleCheckedData_WIG_Account}>Redo</Button>
                      )}
                      {selectedRows_WIG_Rfid.length > 1 && (
                        <Button className="reports-ignoreRedo-btns me-4" variant="outlined" onClick={handleCheckedData_WIG_Rfid}>Redo</Button>
                      )}
                      {selectedRows_WIG_Company.length > 1 && (
                        <Button className="reports-ignoreRedo-btns me-4" variant="outlined" onClick={handleCheckedData_WIG_Company}>Redo</Button>
                      )}

                    {(
                  selectedRows_WEmail.length > 1 ||
                  selectedRows_WAccount.length > 1 ||
                  selectedRows_WRfid.length > 1 ||
                  selectedRows_WCompany.length > 1
                ) && (
                    <div className="tooltip2 ms-2" title="Delete">
                      <Button
                        className=" text-capitalize"
                        onClick={handleCheckedData_Report_MultipleDelete}
                        variant="outlined"
                        style={{
                          padding: "6px 8px",
                          minWidth: "60px",
                          textAlign: "center",
                          borderRadius: "20px",
                          marginRight: "23px",
                          border: "1px solid #ff0000",
                          cursor: "pointer",
                          color: '#ff0000'
                        }}
                      >
                        {/* <SvgIcon fontSize="medium"> */}
                        <img src={deleteIconRed} alt="delete" className="me-2" style={{width: '20px'}} />
                        <span>Delete </span>
                        
                        {/* <DeleteOutlineIcon /> */}
                        {/* </SvgIcon>{" "} */}
                      </Button>
                    </div>

                    )}



                        <input
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{ width: "290px" }}
                          className="me-4 search-style"
                        />

                        {value !== '4' && (
                          <TextField
                            select
                            // value={selectedCompany}
                            value={value === '4' ? '' : selectedCompany} // Set value to empty string if tab 4 is selected
                            onChange={handleCompanyChange}
                            label="Select Company"
                            variant="outlined"
                            sx={{
                              minWidth: 220,
                              '& .MuiOutlinedInput-root': {
                                height: '44px',
                                borderRadius: '30px',
                                padding: '0 14px',
                                '& .MuiSelect-select': {
                                  padding: '10px 14px',
                                },
                              },
                              '& .MuiInputLabel-root': {
                                lineHeight: 'normal',
                              },
                            }}
                            disabled={value === '4'}>
                            {value === '4' ? (
                              <MenuItem value="" disabled />
                            ) : (
                              companies.map((company) => (
                                <MenuItem key={company.company_id} value={company.company_id}>
                                  {company.company_name}
                                </MenuItem>
                              ))
                            )}
                          </TextField>
                        )}

                        <Button
                          className="text-capitalize ms-3"
                          onClick={handleDownloadClick}
                          variant="outlined"
                          style={{
                            padding: "6px 8px",
                            minWidth: "60px",
                            textAlign: "center",
                            borderRadius: "3px",
                            border: "1px solid #1a73cc",
                            cursor: "pointer",
                          }}
                        >
                          <img src={importIcon} alt="import" />
                        </Button>

                      </div>
                    </div>



                    <TabPanel value="1">
                      <TableContainer component={Paper} className="">
                        <Table aria-label="collapsible table">

                          <TableBody>
                            <TableRow
                              className={"bg-table-blue_head"}
                              sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                            >
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"

                                scope="row"
                              >
                                {"First Name"}
                              </TableCell>
                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                              >
                                {"Last Name"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Mobile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Company"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"RFID"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Building"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Parking Profile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Garage Address"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Access Group"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Flash Account"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {""}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>

                            </TableRow>

                            {/* {withoutEmailData.map((row, index) => ( */}
                            {/* {withoutEmailData */}
                            {withoutEmailData
                              .filter((row) =>
                                Object.values(row).some((value) =>
                                  value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                )
                              )
                              .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
                              .map((row, index) => (
                                <TableRow key={index} sx={{ height: '23px' }} >

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}><Checkbox
                                    checked={selectedRows_WEmail.includes(row.customer_id)}
                                    sx={{
                                      '& .MuiSvgIcon-root': {
                                        fontSize: 22, // Smaller size
                                        transform: 'scale(0.75)' // Scale down the checkbox
                                      }
                                    }}
                                    onChange={(event) => handleCheckboxChangeWEmail(event, row.customer_id)}
                                    inputProps={{ 'aria-label': 'select all' }}
                                  />
                                  </TableCell>

                                  <TableCell component="th" scope="row" align='center' className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <div>
                                      <a
                                        href="#"
                                        className="text-danger"
                                        title="Delete"
                                        data-toggle="modal"
                                        onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </a>
                                    </div>
                                  </TableCell>
                                  {/* <TableCell component="th" scope="row" align='center' sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                <div>
                                  <a
                                  href="#"
                                    className="text-danger"
                                    title="Ignore"
                                    data-toggle="modal"
                                  >
                                    <img src={crossIcon} alt="Ignore" />
                                  </a>
                                </div>
                              </TableCell> */}


                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.firstName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.lastName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.company}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.rfid}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.parkingProfile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garageAddress}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.accessGroup}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.account}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-btns btn-width-setting" variant="outlined" onClick={() => { UpdateEmail(row.customer_id, row.firstName, row.lastName) }}>Update Email</Button>
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-ignore-btns" variant="outlined" onClick={() => handleWEmailIgnoreFunction(row.customer_id, row.company_id, "without_email")}>Ignore</Button>
                                  </TableCell>

                                </TableRow>
                              ))}

                          </TableBody>
                        </Table>
                      </TableContainer>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div>
                          <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage} disabled={currentPage === totalPage}>
                            Next
                          </Button>
                        </div>
                        {/* Display the range of items and total count */}
                        {withoutEmailData.length > 1 && (
                          <div className="page-info">
                            {startIndex_Pagination}-{endIndex_Pagination} out of {withoutEmailData.length}
                          </div>
                        )}

                      </div>
                    </TabPanel>

                    <TabPanel value="2">
                      <TableContainer component={Paper} className="">
                        <Table aria-label="collapsible table">

                          <TableBody>
                            <TableRow
                              className={"bg-table-blue_head"}
                              sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                            >
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                sx={{ minWidth: '130px' }}
                                scope="row"
                              >
                                {"First Name"}
                              </TableCell>
                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"

                              >
                                {"Last Name"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"

                              >
                                {"Email"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"

                              >
                                {"Mobile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"

                              >
                                {"Company"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"

                              >
                                {"RFID"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"

                              >
                                {"Building"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '130px' }}
                              >
                                {"Parking Profile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '135px' }}
                              >
                                {"Garage Address"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"

                              >
                                {"Access Group"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {""}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>
                            </TableRow>

                            {/* {withoutAccountData.map((row, index) => ( */}
                            {/* {withoutAccountData */}
                            {withoutAccountData
                              .filter((row) =>
                                Object.values(row).some((value) =>
                                  value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                )
                              )
                              .slice((currentPage_Account - 1) * rowsPerPage_Account, currentPage_Account * rowsPerPage_Account)
                              .map((row, index) => (
                                <TableRow key={index} sx={{ height: '23px' }}>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_WAccount.includes(row.customer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChangeWAccount(event, row.customer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>

                                  <TableCell component="th" scope="row" align='center' sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <div>
                                      <a
                                        href="#"
                                        className="text-danger"
                                        title="Delete"
                                        data-toggle="modal"
                                        onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </a>
                                    </div>
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.firstName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.lastName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.email}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.company}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.rfid}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.parkingProfile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garageAddress}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.accessGroup}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-btns btn-width-setting" variant="outlined" onClick={() => { OpenFlashAccountModal(row.customer_id) }}>Send Flash</Button>
                                  </TableCell>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-ignore-btns" variant="outlined" onClick={() => handleWAccountIgnoreFunction(row.customer_id, row.company_id, "without_account")}>Ignore</Button>
                                  </TableCell>

                                </TableRow>
                              ))}


                          </TableBody>
                        </Table>
                      </TableContainer>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div>
                          <Button onClick={handlePreviousPage_Account} disabled={currentPage_Account === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_Account} disabled={currentPage_Account === totalPage_Account}>
                            Next
                          </Button>
                        </div>
                        {/* Display the range of items and total count */}
                        {withoutAccountData.length > 1 && (
                          <div className="page-info">
                            {startIndex_Pagination_Account}-{endIndex_Pagination_Account} out of {withoutAccountData.length}
                          </div>
                        )}
                      </div>
                    </TabPanel>

                    <TabPanel value="3">
                      <TableContainer component={Paper} className="">
                        <Table aria-label="collapsible table">

                          <TableBody>
                            <TableRow
                              className={"bg-table-blue_head"}
                              sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px", padding: '20px 16px' }}
                            >

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                sx={{ minWidth: '135px' }}
                                scope="row"
                              >
                                {"First Name"}
                              </TableCell>
                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '135px' }}
                              >
                                {"Last Name"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Email"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Mobile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Company"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Building"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '145px' }}
                              >
                                {"Parking Profile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '145px' }}
                              >
                                {"Garage Address"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '145px' }}
                              >
                                {"Access Group"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '145px' }}
                              >
                                {"Flash Account"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {""}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>
                            </TableRow>

                            {/* {withoutRfidData.map((row, index) => ( */}
                            {/* {withoutRfidData */}
                            {withoutRfidData
                              .filter((row) =>
                                Object.values(row).some((value) =>
                                  value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                )
                              )
                              .slice((currentPage_Rfid - 1) * rowsPerPage_Rfid, currentPage_Rfid * rowsPerPage_Rfid)
                              .map((row, index) => (
                                <TableRow key={index} sx={{ height: '23px' }}>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_WRfid.includes(row.customer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChangeWRfid(event, row.customer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>


                                  <TableCell component="th" scope="row" align='center' sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <div>
                                      <a
                                        href="#"
                                        className="text-danger"
                                        title="Delete"
                                        data-toggle="modal"
                                        onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </a>
                                    </div>
                                  </TableCell>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.firstName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.lastName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.email}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.company}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.parkingProfile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garageAddress}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.accessGroup}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.account}
                                  </TableCell>
                                  <TableCell sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-btns btn-width-setting-rfid" variant="outlined" onClick={() => { OpenRfidModal(row.customer_id, row.email) }}>Update RFID</Button>
                                  </TableCell>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-ignore-btns" variant="outlined" onClick={() => handleWRfidIgnoreFunction(row.customer_id, row.company_id, "without_rfid")}>Ignore</Button>
                                  </TableCell>
                                </TableRow>
                              ))}


                          </TableBody>
                        </Table>
                      </TableContainer>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div>
                          <Button onClick={handlePreviousPage_Rfid} disabled={currentPage_Rfid === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_Rfid} disabled={currentPage_Rfid === totalPage_Rfid}>
                            Next
                          </Button>
                        </div>
                        {/* Display the range of items and total count */}
                        {withoutRfidData.length > 1 && (
                          <div className="page-info">
                            {startIndex_Pagination_Rfid}-{endIndex_Pagination_Rfid} out of {withoutRfidData.length}
                          </div>
                        )}
                      </div>

                    </TabPanel>
                    <TabPanel value="4">

                      <TableContainer component={Paper} className="">
                        <Table aria-label="collapsible table">

                          <TableBody>
                            <TableRow
                              className={"bg-table-blue_head"}
                              sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                            >

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                sx={{ minWidth: '145px' }}
                                scope="row"
                              >
                                {"First Name"}
                              </TableCell>
                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '135px' }}
                              >
                                {"Last Name"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Email"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Mobile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"RFID"}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {"Building"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '145px' }}
                              >
                                {"Parking Profile"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '145px' }}
                              >
                                {"Garage Address"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '135px' }}
                              >
                                {"Access Group"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ minWidth: '135px' }}
                              >
                                {"Flash Account"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                              >
                                {""}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '4rem' }}
                              >
                                {" "}
                              </TableCell>
                            </TableRow>

                            {/* {withoutCompanyData.map((row, index) => ( */}
                            {/* {withoutCompanyData */}
                            {withoutCompanyData
                              .filter((row) =>
                                Object.values(row).some((value) =>
                                  value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                )
                              )
                              .slice((currentPage_Company - 1) * rowsPerPage_Company, currentPage_Company * rowsPerPage_Company)
                              .map((row, index) => (
                                <TableRow key={index} sx={{ height: '23px' }}>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_WCompany.includes(row.customer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChangeWCompany(event, row.customer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>

                                  <TableCell component="th" scope="row" align='center' sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <div>
                                      <a
                                        href="#"
                                        className="text-danger"
                                        title="Delete"
                                        data-toggle="modal"
                                        onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </a>
                                    </div>
                                  </TableCell>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.firstName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.lastName}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.email}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.rfid}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.parkingProfile}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garageAddress}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.accessGroup}</TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>

                                    {row.account}
                                  </TableCell>
                                  <TableCell sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-btns btn-width-setting-company" variant="outlined" onClick={() => { OpenCompanyModal(row.customer_id) }}>Update Company</Button>
                                  </TableCell>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-ignore-btns" variant="outlined" onClick={() => handleWCompanyIgnoreFunction(row.customer_id, "without_company")}>Ignore</Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <Button onClick={handlePreviousPage_Company} disabled={currentPage_Company === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_Company} disabled={currentPage_Company === totalPage_Company}>
                            Next
                          </Button>
                        </div>


                        {/* Display the range of items and total count */}
                        {withoutCompanyData.length > 1 && (
                          <div className="page-info">
                            {startIndex_Pagination_Company}-{endIndex_Pagination_Company} out of {withoutCompanyData.length}
                          </div>
                        )}
                      </div>
                    </TabPanel>


                    <TabPanel value="5">

                      <div className="accordian-border">
                        {/* Accordian For Customers without email */}
                        <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  fontSize: '30px',  // Style for the icon
                                  color: '#1998f0 !important',  // Color for the icon
                                  marginRight: '10px'
                                }}
                              />
                            }
                            aria-controls="panel1-content"
                            id="panel1-header"
                            sx={{
                              flexDirection: 'row-reverse',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#004a7d !important',  // Color for the text
                              }}
                            >
                              CUSTOMERS WITHOUT EMAIL
                              {/* Customers Without Email */}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <TableContainer component={Paper} className="">
                              <Table aria-label="collapsible table">

                                <TableBody>
                                  <TableRow
                                    className={"bg-table-blue_head"}
                                    sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                                  >

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"

                                      scope="row"
                                    >
                                      {"First Name"}
                                    </TableCell>
                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Last Name"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Mobile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Company"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"RFID"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Building"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Parking Profile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Garage Address"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Access Group"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Flash Account"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>


                                  </TableRow>

                                  {/* {withoutEmailData.map((row, index) => ( */}
                                  {withoutEmailData_IgnoredTab.length > 0 ? (
                                  withoutEmailData_IgnoredTab
                                    .slice((currentPage_IgnoreEmail - 1) * rowsPerPage_IgnoreEmail, currentPage_IgnoreEmail * rowsPerPage_IgnoreEmail)
                                    .map((row, index) => (
                                      <TableRow key={index} sx={{ height: '23px' }} >

                                    <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_WIG_Email.includes(row.customer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChangeWIG_Email(event, row.customer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>

                                        <TableCell component="th" scope="row" align='center' className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <div>
                                            <a
                                              href="#"
                                              className="text-danger"
                                              title="Delete"
                                              data-toggle="modal"
                                              onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                            >
                                              <img src={deleteIcon} alt="delete" />
                                            </a>
                                          </div>
                                        </TableCell>

                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.first_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.last_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.company}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.rfid}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.profile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garage_address}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.access_group}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.account}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Button className="reports-ignoreRedo-btns" variant="outlined" onClick={() => handleWEmailRedoFunction(row.customer_id, row.company_id, "without_email")}>Redo</Button>
                                        </TableCell>


                                      </TableRow>

                                    ))
                                  ) : (
                                    <TableRow>
                                        <TableCell colSpan={12} align="center">
                                        <span className="no-data-text">No data found</span>
                                        </TableCell>
                                      </TableRow>
                                    )}
                                    {/* ))} */}

                                </TableBody>
                              </Table>
                            </TableContainer>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                              <div>
                                {/* <Button onClick={handlePreviousPage} disabled={currentPage === 1}> */}
                                <Button onClick={handlePreviousPage_IgnoreEmail} disabled={currentPage_IgnoreEmail === 1}>
                                  Previous
                                </Button>
                                {/* <Button onClick={handleNextPage} disabled={currentPage === totalPage}> */}
                                <Button onClick={handleNextPage_IgnoreEmail} disabled={currentPage_IgnoreEmail === totalPage_Email_ForIgnoreEmail}>
                                  Next
                                </Button>
                              </div>
                              {/* Display the range of items and total count */}
                              {withoutEmailData_IgnoredTab.length > 1 && (
                                <div className="page-info">
                                  {startIndex_W_EmailPagination_Ignore}-{endIndex_W_EmailPagination_Pagination_Ignore} out of {withoutEmailData_IgnoredTab.length}
                                </div>
                              )}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        {/* Accordian For Customers without email Ends */}

                        <Accordion expanded={expanded === 'panel2'} onChange={handleAccordionChange('panel2')}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  fontSize: '30px',  // Style for the icon
                                  color: '#1998f0 !important',  // Color for the icon
                                  marginRight: '10px'
                                }}
                              />
                            }
                            aria-controls="panel2-content"
                            id="panel2-header"
                            sx={{
                              flexDirection: 'row-reverse',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#004a7d !important',  // Color for the text
                              }}
                            >
                              CUSTOMERS WITHOUT ACCOUNT
                              {/* Customers Without Account */}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <TableContainer component={Paper} className="">
                              <Table aria-label="collapsible table">

                                <TableBody>
                                  <TableRow
                                    className={"bg-table-blue_head"}
                                    sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                                  >
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"

                                      scope="row"
                                    >
                                      {"First Name"}
                                    </TableCell>
                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Last Name"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Email"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Mobile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Company"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"RFID"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Building"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Parking Profile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Garage Address"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Access Group"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>

                                  </TableRow>

                                  {/* {withoutAccountData.map((row, index) => ( */}
                                  {withoutAccountData_IgnoreTab.length > 0 ? (
                                  withoutAccountData_IgnoreTab
                                    .slice((currentPage_Account - 1) * rowsPerPage_Account, currentPage_Account * rowsPerPage_Account)
                                    .map((row, index) => (
                                      <TableRow key={index} sx={{ height: '23px' }}>

                                    <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_WIG_Account.includes(row.customer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChangeWIG_Account(event, row.customer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>
                                        <TableCell component="th" scope="row" align='center' sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <div>
                                            <a
                                              href="#"
                                              className="text-danger"
                                              title="Delete"
                                              data-toggle="modal"
                                              onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                            >
                                              <img src={deleteIcon} alt="delete" />
                                            </a>
                                          </div>
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.first_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.last_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.email}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.company}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.rfid}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.profile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garage_address}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.accessGroup}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Button className="reports-ignoreRedo-btns" variant="outlined" onClick={() => handleWAccountRedoFunction(row.customer_id, row.company_id, "without_account")}>Redo</Button>
                                        </TableCell>


                                      </TableRow>
                                      ))
                                    ) : (
                                      <TableRow>
                                          <TableCell colSpan={12} align="center">
                                          <span className="no-data-text">No data found</span>
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    {/* ))} */}


                                </TableBody>
                              </Table>
                            </TableContainer>

                            <div className="d-flex align-items-center justify-content-between mb-4">
                              <div>
                                <Button onClick={handlePreviousPage_Account} disabled={currentPage_Account === 1}>
                                  Previous
                                </Button>
                                <Button onClick={handleNextPage_Account} disabled={currentPage_Account === totalPage_Account_ForIgnoreAccount}>
                                  Next
                                </Button>
                              </div>
                              {/* Display the range of items and total count */}
                              {withoutAccountData_IgnoreTab.length > 1 && (
                                <div className="page-info">
                                  {startIndex_W_AccountPagination_Account}-{endIndex_W_AccountPaginationPagination_Account} out of {withoutAccountData_IgnoreTab.length}
                                </div>
                              )}
                            </div>
                          </AccordionDetails>
                        </Accordion>

                        {/* Accordian of customers w/o rfid */}
                        <Accordion expanded={expanded === 'panel3'} onChange={handleAccordionChange('panel3')}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  fontSize: '30px',  // Style for the icon
                                  color: '#1998f0 !important',  // Color for the icon
                                  marginRight: '10px'
                                }}
                              />
                            }
                            aria-controls="panel3-content"
                            id="panel3-header"
                            sx={{
                              flexDirection: 'row-reverse',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#004a7d !important',  // Color for the text
                              }}
                            >
                              CUSTOMERS WITHOUT RFID
                              {/* Customers Without RFID */}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <TableContainer component={Paper} className="">
                              <Table aria-label="collapsible table">

                                <TableBody>
                                  <TableRow
                                    className={"bg-table-blue_head"}
                                    sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                                  >

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"

                                      scope="row"
                                    >
                                      {"First Name"}
                                    </TableCell>
                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Last Name"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Email"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Mobile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Company"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Building"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Parking Profile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Garage Address"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Access Group"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Flash Account"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>

                                  </TableRow>

                                  {/* {withoutRfidData.map((row, index) => ( */}
                                  {withoutRfidData_IgnoreTab.length > 0 ? (
                                   withoutRfidData_IgnoreTab
                                    .slice((currentPage_Rfid - 1) * rowsPerPage_Rfid, currentPage_Rfid * rowsPerPage_Rfid)
                                    .map((row, index) => (
                                      <TableRow key={index} sx={{ height: '23px' }}>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_WIG_Rfid.includes(row.customer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChangeWIG_Rfid(event, row.customer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>
                                        <TableCell component="th" scope="row" align='center' sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <div>
                                            <a
                                              href="#"
                                              className="text-danger"
                                              title="Delete"
                                              data-toggle="modal"
                                              onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                            >
                                              <img src={deleteIcon} alt="delete" />
                                            </a>
                                          </div>
                                        </TableCell>

                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.first_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.last_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.email}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.company}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.profile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garage_address}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.access_group}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.account}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Button className="reports-ignoreRedo-btns" variant="outlined" onClick={() => handleWRfidRedoFunction(row.customer_id, row.company_id, "without_rfid")}>Redo</Button>
                                        </TableCell>

                                      </TableRow>

                                            ))
                                            ) : (
                                              <TableRow>
                                                  <TableCell colSpan={12} align="center">
                                                  <span className="no-data-text">No data found</span>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                    {/* ))} */}


                                </TableBody>
                              </Table>
                            </TableContainer>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                              <div>
                                <Button onClick={handlePreviousPage_Rfid} disabled={currentPage_Rfid === 1}>
                                  Previous
                                </Button>
                                <Button onClick={handleNextPage_Rfid} disabled={currentPage_Rfid === totalPage_Rfid_ForIgnoreRfid}>
                                  Next
                                </Button>
                              </div>
                              {/* Display the range of items and total count */}
                              {withoutRfidData_IgnoreTab.length > 1 && (
                                <div className="page-info">
                                  {startIndex_W_Pagination_Rfid_Ignore}-{endIndex_W_Pagination_Rfid_Ignore} out of {withoutRfidData_IgnoreTab.length}
                                </div>
                              )}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        {/* Accordian of customers w/o rfid Ends*/}

                        <Accordion expanded={expanded === 'panel4'} onChange={handleAccordionChange('panel4')}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  fontSize: '30px',  // Style for the icon
                                  color: '#1998f0 !important',  // Color for the icon
                                  marginRight: '10px'
                                }}
                              />
                            }
                            aria-controls="panel4-content"
                            id="panel4-header"
                            sx={{
                              flexDirection: 'row-reverse',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#004a7d !important',  // Color for the text
                              }}
                            >
                              CUSTOMERS WITHOUT COMPANY
                              {/* Customers Without Company */}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <TableContainer component={Paper} className="">
                              <Table aria-label="collapsible table">

                                <TableBody>
                                  <TableRow
                                    className={"bg-table-blue_head"}
                                    sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                                  >

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"

                                      scope="row"
                                    >
                                      {"First Name"}
                                    </TableCell>
                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Last Name"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Email"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Mobile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"RFID"}
                                    </TableCell>


                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Building"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Parking Profile"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Garage Address"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Access Group"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                    >
                                      {"Flash Account"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '4rem' }}
                                    >
                                      {" "}
                                    </TableCell>

                                  </TableRow>

                                  {/* {withoutCompanyData.map((row, index) => ( */}
                                  {withoutCompanyData_IgnoreTab.length > 0 ? (
                                   withoutCompanyData_IgnoreTab
                                    .filter((row) =>
                                      Object.values(row).some((value) =>
                                        value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                      )
                                    )
                                    .slice((currentPage_Company - 1) * rowsPerPage_Company, currentPage_Company * rowsPerPage_Company)
                                    .map((row, index) => (
                                      <TableRow key={index} sx={{ height: '23px' }}>

                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_WIG_Company.includes(row.customer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChangeWIG_Company(event, row.customer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>
                                        <TableCell component="th" scope="row" align='center' sx={{ padding: '8px' }} className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <div>
                                            <a
                                              href="#"
                                              className="text-danger"
                                              title="Delete"
                                              data-toggle="modal"
                                              onClick={(event) => handleDeleteReport_W_Email(event,row)}
                                            >
                                              <img src={deleteIcon} alt="delete" />
                                            </a>
                                          </div>
                                        </TableCell>

                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.first_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.last_name}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.email}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.mobile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.rfid}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.building}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.profile}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.garage_address}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>{row.access_group}</TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>

                                          {row.account}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Button className="reports-ignoreRedo-btns" variant="outlined" onClick={() => handleWCompanyRedoFunction(row.customer_id, "without_company")}>Redo</Button>
                                        </TableCell>

                                      </TableRow>
                                      ))
                                    ) : (
                                      <TableRow>
                                          <TableCell colSpan={12} align="center">
                                          <span className="no-data-text">No data found</span>
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    {/* ))} */}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                              <div>
                                <Button onClick={handlePreviousPage_Company} disabled={currentPage_Company === 1}>
                                  Previous
                                </Button>
                                <Button onClick={handleNextPage_Company} disabled={currentPage_Company === totalPage_Company_ForIgnoreCompany}>
                                  Next
                                </Button>
                              </div>

                              {/* Display the range of items and total count */}
                              {withoutCompanyData_IgnoreTab.length > 1 && (
                                <div className="page-info">
                                  {startIndex_W_Pagination_Company_Ignore}-{endIndex_W_Pagination_Company_Ignore} out of {withoutCompanyData_IgnoreTab.length}
                                </div>
                              )}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>

                    </TabPanel>


                  </>
                )}


                {/* <Modal
            open={updateEmailModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
           <Box sx={style}>
            <h6 style={{ textAlign: 'left' }}>Update Email</h6>
            <hr />
            
            <form >
            <TextField
              type="text"
              variant="outlined"
              color="secondary"
              label="Email"
              name="email"
              fullWidth
              required
              sx={{ mb: 2 }}
              InputLabelProps={{
                shrink: true,
              }}
            />

              <div className="text-end mt-2">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                className="me-4 btn-sty"
              >
                Ok
              </Button>
              <Button
                variant="contained"
                color="error"
                size="large"
                className="btn-sty"
                onClick={handleCloseUpdateEmail}
              >
                Cancel
              </Button>
              </div>
            </form>
          </Box>
        </Modal> */}
                {/* Update Email Modal */}
                {/* Generate reports */}
                <Modal
                  open={updateGenerateModal}
                  onClose={handleGenerateModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Generate Report</h6>
                      <IconButton onClick={handleGenerateModal} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <hr />
                    <form style={{padding: '20px 21px'}} onSubmit={handleSubmit_GReport}>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox checked={withoutEmail_GReport}
                          onChange={(e) => setWithoutEmail_GReport(e.target.checked)} />}
                          label="Customers Without Email"
                        />
                        <FormControlLabel control={<Checkbox checked={withoutAccount_GReport}
                          onChange={(e) => setWithoutAccount_GReport(e.target.checked)} />}
                          label="Customers Without Account" />
                        <FormControlLabel control={<Checkbox checked={withoutRfid_GReport}
                          onChange={(e) => setWithoutRfid_GReport(e.target.checked)} />}
                          label="Customers Without RFID" />
                        <FormControlLabel control={<Checkbox
                          checked={withoutCompany_GReport}
                          onChange={(e) => setWithoutCompany_GReport(e.target.checked)} />}
                          label="Customers Without Company" />
                      </FormGroup>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                        >
                          Download
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleGenerateModal}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Update Email Modal End*/}
                {/* end generate reports */}
                {/* Update Email Modal */}


                <Modal
                  className="export-style"
                  open={updateEmailModal}
                  onClose={handleCloseUpdateEmail}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    {/* Header with blue background */}
                    <div
                      style={{
                        padding: '10px 15px',
                        color: 'black',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderTopLeftRadius: '4px',
                        borderTopRightRadius: '4px',
                        borderBottom: '1px solid rgb(215 215 215)'
                      }}
                    >
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Update Email</h6>
                      <IconButton onClick={handleCloseUpdateEmail} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>

                    {/* Form Content */}
                    <div style={{ padding: '20px' }}>
                      <form className="mt-4" onSubmit={handleSubmitEmail}>
                        <TextField
                          type="email"
                          variant="outlined"
                          color="secondary"
                          label="Email"
                          name="email"
                          fullWidth
                          required
                          onChange={(e) => setEmailModalData(e.target.value)}
                          sx={{ mb: 2, ...textFieldStyle }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />

                        <Radio.Group onChange={handleEmailtypeRadioChange} value={UpdateEmailType}>
                          <Radio value="sync" style={{
                            background: '#f5f5f5',
                            padding: '10px 15px',
                            borderRadius: '20px'
                          }}>Update email and sync with other systems</Radio>
                          <Radio value="local" style={{
                            background: '#f5f5f5',
                            padding: '10px 15px',
                            borderRadius: '20px',
                            marginTop: '15px'
                          }}>Update email on credential only</Radio>
                        </Radio.Group>

                        {/* Action Buttons */}
                        <div className="text-end mt-4">
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="large"
                            className="me-2 btn-sty"
                            sx={{ mr: 2, ...buttonStyle }}

                          >
                            Ok
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            size="large"
                            className="btn-sty"
                            sx={buttonStyle}
                            onClick={handleCloseUpdateEmail}

                          >
                            Cancel
                          </Button>
                        </div>
                      </form>
                    </div>
                  </Box>
                </Modal>




                {/* Update Email Modal End*/}

                {/* Send Flash modal */}
                <Modal
                  open={flashAccountModal}
                  onClose={handleCloseUpdateAccount}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Send Flash</h6>
                      <IconButton onClick={handleCloseUpdateAccount} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to add this customer to the flash email?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={handleSendFlash}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCloseUpdateAccount}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Send Flash modal Ends*/}


                {/* update Rfid modal */}
                <Modal
                  open={rfidModal}
                  onClose={handleCloseRfid}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Update RFID</h6>
                      <IconButton onClick={handleCloseRfid} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <hr />
                    <form style={{padding: '20px 21px'}} onSubmit={handleSubmitRfid}>
                      <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
                        <TextField
                          type="text"
                          variant="outlined"
                          color="secondary"
                          label="Facility Code"
                          onChange={handlefacilityChange}
                          value={facilityCode}
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <TextField
                          type="text"
                          variant="outlined"
                          color="secondary"
                          label=" Card Id"
                          onChange={handleCardIdChange}
                          value={cardId}
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Stack>
                      <TextField
                        type="text"
                        disabled
                        variant="outlined"
                        color="secondary"
                        label="RFID"
                        value={rfid}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                        >
                          Ok
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCloseRfid}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* update Rfid modal Ends*/}


                <Modal
                  open={companyModal}
                  onClose={CloseCompanyModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Update Company</h6>
                      <IconButton onClick={CloseCompanyModal} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    
                    <form style={{padding: '20px 21px'}} onSubmit={handleUpdateCompany}>
                      <TextField
                        select
                        // value={selectedCompany}
                        fullWidth
                        onChange={(e) => CompanyChange_Modal(e.target.value)}
                        value={selectedCompanyForModal}
                        label="Select Company"
                        variant="outlined"
                        className="mb-3"
                        sx={{
                          minWidth: 220,
                          '& .MuiOutlinedInput-root': {
                            height: '44px',
                            borderRadius: '30px',
                            padding: '0 14px',
                            '& .MuiSelect-select': {
                              padding: '10px 14px',
                            },
                          },
                          '& .MuiInputLabel-root': {
                            lineHeight: 'normal',
                          },
                        }}
                      >

                        {companies_formodals.map((company) => (
                          <MenuItem key={company.company_id} value={company.company_id}>
                            {company.company_name}
                          </MenuItem>
                        ))}

                      </TextField>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                        >
                          Ok
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={CloseCompanyModal}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Ignore conformation modal */}

                <Modal
                  open={openCheckedIgnoreModal}
                  onClose={handleCheckedIgnoreClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Ignore</h6>
                      <IconButton onClick={handleCheckedIgnoreClose} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to ignore all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          // onClick={(event) => handleChecked_WEmailIgnoreSubmit(event)}
                          onClick={(event) => handleChecked_WEmailIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Ignore conformation w/o Email modal Ends*/}

                {/* Multiple Ignore conformation w/o Account modal */}

                <Modal
                  open={openCheckedIgnoreModal_WAccount}
                  onClose={handleCheckedIgnoreClose_WAccount}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Ignore</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_WAccount} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to ignore all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_WAccountIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_WAccount}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Ignore conformation w/o Account modal Ends*/}

                {/* Multiple Ignore conformation w/o Rfid modal */}

                <Modal
                  open={openCheckedIgnoreModal_WRfid}
                  onClose={handleCheckedIgnoreClose_WRfid}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Send Flash</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_WRfid} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to ignore all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_WRfidIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_WRfid}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Ignore conformation w/o Rfid modal Ends*/}

                {/* Multiple Ignore conformation w/o Company modal */}

                <Modal
                  open={openCheckedIgnoreModal_WCompany}
                  onClose={handleCheckedIgnoreClose_WCompany}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Send Flash</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_WCompany} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to ignore all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_WCompanyIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_WCompany}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Ignore conformation w/o Company modal Ends*/}

                {/* Multiple Redo conformation w/o  Ignored Email modal */}

                <Modal
                  open={openCheckedIgnoreModal_WIG_Email}
                  onClose={handleCheckedIgnoreClose_WIG_Email}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Redo</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_WIG_Email} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to Redo all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_WIGEmailIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_WIG_Email}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Redo conformation w/o Ignored Email modal Ends*/}

                {/* Multiple Redo conformation w/o  Ignored Account modal */}

                <Modal
                  open={openCheckedIgnoreModal_WIG_Account}
                  onClose={handleCheckedIgnoreClose_WIG_Account}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Redo</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_WIG_Account} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to Redo all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_WIGAccountIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_WIG_Account}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Redo conformation w/o Ignored Email modal Ends*/}

                {/* Multiple Redo conformation w/o  Ignored Rfid modal */}

                <Modal
                  open={openCheckedIgnoreModal_WIG_Rfid}
                  onClose={handleCheckedIgnoreClose_WIG_Rfid}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Redo</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_WIG_Rfid} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to Redo all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_WIGRfidIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_WIG_Rfid}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Redo conformation w/o Ignored Rfid modal Ends*/}

                {/* Multiple Redo conformation w/o  Ignored Company modal */}

                <Modal
                  open={openCheckedIgnoreModal_WIG_Company}
                  onClose={handleCheckedIgnoreClose_WIG_Company}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Redo</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_WIG_Company} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to Redo all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_WIGCompanyIgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_WIG_Company}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* Multiple Redo conformation w/o Ignored Company modal Ends*/}

                 {/* w/o  Email Delete conformation modal */}

                 <ConformationModal
                  open={isModalOpen_confDelete_W_Email}
                  onClose={handleDeleteModalClose_W_Email}
                  onSubmitModal={handleDelete_W_Email}
                  title="Delete"
                  message="Are you sure you want to delete the selected customer?"
                />

                <ConformationModal
                  open={openCheckedIgnoreModal_Report_MultipleDelete}
                  onClose={handleDeleteModalClose_Report_MultipleDelete}
                  title="Delete"
                  message="Are you sure you want to delete the selected customers?"
                  // onSubmitModal={handleMultipleDelete_AVG}
                />

                 {/* <Modal
                  open={isModalOpen_confDelete_W_Email}
                  onClose={handleDeleteModalClose_W_Email}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Delete</h6>
                      <IconButton onClick={handleDeleteModalClose_W_Email} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to delete the selected customer?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={handleDelete_W_Email}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleDeleteModalClose_W_Email}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal> */}

                {/* w/o  Email Delete conformation modal Ends*/}




              </TabContext>
            </Box>
          </div>
        </Box>
      </Box>
    </React.Fragment>
  )


}
export default Reports;